<template>
  <v-row>
    <v-col cols="12" v-for="(item, key) in alerts" :key="key">
      <alert-item :alert="item" />
    </v-col>
  </v-row>
</template>

<script>
import AlertItem from './AlertItem'

export default {
  name: 'AlertsTable',
  components: {
    AlertItem
  },
  props: {
    alerts: {
      type: Array,
      required: true,
      default: () => ([])
    },
  }
}
</script>
